import { H3, useDialog } from '@wheely/ui-kit';
import { FormattedMessage } from 'react-intl';

import { Button } from '@src-common/view/adapters/Button';

import s from './Blocking.module.css';

interface IProps {
  onDismiss: () => void;
}

const DismissDriverDialog = ({ onDismiss }: IProps) => (
  <div className={s.root}>
    <FormattedMessage
      defaultMessage="A chauffeur will be deleted from your account. Continue?"
      id="4NM/pj"
      description="Dismiss driver prompt"
    />
    <div className={s.actions}>
      <Button onClick={onDismiss} intent={'danger'}>
        <FormattedMessage defaultMessage="Yes" id="LeRDjJ" description="Yes button text" />
      </Button>
    </div>
  </div>
);

const useOpenDismissDriverDialog = () => {
  const { openDialog, closeDialogs } = useDialog();

  const openDismissDriverDialog = ({ onDismiss }: IProps) => {
    openDialog(() => <DismissDriverDialog onDismiss={onDismiss} />, {
      title: (
        <H3>
          <FormattedMessage defaultMessage="Confirm" id="xiyJOg" description="Confirm action" />
        </H3>
      ),
      bodyClassName: s.dialog,
    });
  };

  return { closeDismissDriverDialog: closeDialogs, openDismissDriverDialog };
};

export { useOpenDismissDriverDialog, DismissDriverDialog };
